import { createSlice } from "@reduxjs/toolkit";

const initial_state = {
  tickets: [],
  selectedTicket: null,
  total: 0,
  page: 1,
  pages: 1,
  limit: 10,
  loading: false,
  isError: false,
  errorMessage: "",
};

const adminSupportSlice = createSlice({
  name: "ADMIN_SUPPORT",
  initialState: initial_state,
  reducers: {
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setError: (state, { payload }) => {
      state.isError = true;
      state.errorMessage = payload;
    },
    clearError: (state) => {
      state.isError = false;
      state.errorMessage = "";
    },
    setTickets: (state, { payload }) => {
      state.tickets = payload.data || [];
      state.total = payload.pagination?.total || 0;
      state.page = payload.pagination?.page || 1;
      state.pages = payload.pagination?.pages || 1;
      state.limit = payload.pagination?.limit || 10;
    },
    setSelectedTicket: (state, { payload }) => {
      state.selectedTicket = payload;
    },
    updateTicketStatusLocal: (state, { payload }) => {
      const { ticketId, status } = payload;
      const idx = state.tickets.findIndex((t) => t._id === ticketId);
      if (idx !== -1) state.tickets[idx].status = status;
      if (state.selectedTicket && state.selectedTicket._id === ticketId) {
        state.selectedTicket.status = status;
      }
    },
  },
});

export const { setLoading, setError, clearError, setTickets, setSelectedTicket, updateTicketStatusLocal } = adminSupportSlice.actions;
export default adminSupportSlice.reducer;


